import { render, staticRenderFns } from "./NumberGrow.vue?vue&type=template&id=23d77131&"
import script from "./NumberGrow.vue?vue&type=script&lang=js&"
export * from "./NumberGrow.vue?vue&type=script&lang=js&"
import style0 from "./NumberGrow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports